import { Container, Row, Col } from 'react-bootstrap';
import PageHero from '../components/PageHero';

const contacts = [
  {
    title: 'General information',
    email: 'info@eac2027.si',
    note: 'Your request will most likely be processed by Ana Kroflič.',
  },
  {
    title: 'Sponsorships',
    email: 'sponsors@eac2027.si',
    note: 'Your request will most likely be processed by Martin Šala or Christof Asbach.',
  },
  {
    title: 'Programme information',
    email: 'program@eac2027.si',
    note: 'Your request will most likely be processed by Martin Rigler.',
  },
  {
    title: 'Registration information',
    email: 'registration@eac2027.si',
  },
];

export default function InfoContacts() {
  return (
    <div className="page-content">
      <PageHero
        eyebrow="Conference info"
        title="Contacts"
        intro="For questions about EAC2027, contact the most appropriate team member."
      />

      <main className="info-page pt-5 pb-5">
        <Container className="pt-5">
          <Row className="justify-content-center">
            <Col lg={10} xl={9}>

              <section className="info-section">
                <h2 className='h1'>Contact points</h2>
                <p>
                  Please use the <span className="text-marker">contact address that best matches your request.</span> This helps us direct your message to
                  the right member of the EAC2027 team.
                </p>

                <div className="contact-list">
                  {contacts.map((contact) => (
                    <div className="contact-item" key={contact.email}>
                      <h3>{contact.title}</h3>

                      <p className="contact-email">
                        <a href={`mailto:${contact.email}`}>{contact.email}</a>
                      </p>

                      {contact.note && <p>{contact.note}</p>}
                    </div>
                  ))}
                </div>
              </section>
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
}